import React, { useEffect, useState } from "react";

import config from "@app/config";
import { useShopify } from "@app/scripts/react-hooks/shopify";
import { ProductCarousel } from "@app/scripts/react-product-carousel/components/ProductCarousel";
import { shopify } from "@app/scripts/utils/graphql";
import { GET_PRODUCTS_BY_ID } from "@app/scripts/utils/queries";

import type { GQLProduct, NormalisedProduct, RecentlyViewed } from "@app/scripts/types";

type Props = {
  columnsDesktop: number;
  columnsMobile: number;
  disabledMobileSlider: boolean;
  disabledDesktopSlider: boolean;
  transparentButtons: boolean;
};

export const RecentProducts: React.FC<Props> = ({
  columnsDesktop,
  columnsMobile,
  disabledDesktopSlider,
  disabledMobileSlider,
  transparentButtons,
}) => {
  const [products, setProducts] = useState<NormalisedProduct[]>([]);
  const { normaliseProduct } = useShopify();

  useEffect(() => {
    const getProducts = async () => {
      let recentlyViewed: RecentlyViewed[] = JSON.parse(localStorage.getItem(config.keys.recently_viewed) ?? "[]");

      if (recentlyViewed.length) {
        const data = await shopify(GET_PRODUCTS_BY_ID, {
          ids: recentlyViewed.map((recent) => `gid://shopify/Product/${recent.id}`),
        });

        if (data?.nodes) {
          const filtered = data.nodes
            ?.filter(
              (product: GQLProduct) => product?.handle && !window.location.pathname.includes(`/${product.handle}`)
            )
            ?.map((product: GQLProduct) => normaliseProduct(product));

          if (filtered?.length) {
            setProducts(filtered);
          } else {
            // hide recently viewed if no products are available
            document.querySelectorAll(".recently-viewed")?.forEach((elem) => elem.classList.add("hidden"));
          }
        }
      }
    };
    getProducts();
  }, []);

  return products.length > 0 ? (
    <ProductCarousel
      originalClass="product-grid item-carousel columns-desktop__4"
      columnsDesktop={columnsDesktop}
      columnsMobile={columnsMobile}
      disabledDesktop={disabledDesktopSlider}
      products={products}
      disabledMobile={disabledMobileSlider}
      scrollbarMobile={false}
      transparentBtns={transparentButtons}
      hasQuickAddDrawer={false}
      showArrows={true}
      showScrollbar={true}
    />
  ) : null;
};
